<!-- 挂载详情Tab -->
<template>
    <div>
        <div class="detailContent ">
            <!-- 监测点详细的查阅模式 -->
            <div class="uk-flex-1 uk-margin-large-right">
                <ul v-show="isShowEdit">
                    <li v-for="item in baseMsg" :key="item.key">
                        <span>
                            <div style="display: inline-block;width:150px;" class="uk-text-right uk-margin-small-right">{{
                                $t(item['text']) }}
                            </div>
                            <i class="iconfont icon-biaodian" v-show="item.key === 'isTrace' && detailObj[item.key] === 1"
                                @click="handleToMAPFn"></i>
                            <!--<span v-if="item.key === 'alarmSwitch' && detailObj.alarmTriggerList">-->
                            <!--    <el-tag effect="dark" :key="trigger.id" v-for="trigger in detailObj.alarmTriggerList"-->
                            <!--        @click="currentTriggerId = trigger.id" class="cursor-pointer icon-margin">{{-->
                            <!--            trigger.name-->
                            <!--        }}</el-tag>-->
                            <!--    &lt;!&ndash; <i class="el-icon-setting" v-show="item.key === 'alarmSwitch' && detailObj[item.key] === 1" @click="handleToAlarmSetFn"></i> &ndash;&gt;-->
                            <!--</span>-->
                            <span v-if="item.key === 'mode'">
                                <span>{{ $store.state.carrierMode[detailObj[item.key]] &&
                                  $t('asset.mode.' + $store.state.carrierMode[detailObj[item.key]].content) }}</span>
                            </span>
                            <span v-else-if="item.key === 'sampleStrategy' && detailObj[item.key]">
                                {{ $t(sampleSrategy[detailObj[item.key]].title) }}
                                <i class="el-icon-question cursor-pointer"
                                    :title="sampleSrategy[detailObj[item.key]].desc"></i>
                            </span>
                            <span v-else>{{ switchFn(detailObj[item.key], item.key) }}</span>
                        </span>
                    </li>
                    <li>
                        <div style="display: inline-block;width:150px;" class="uk-margin-small-right"></div>
                        <el-button type="primary" v-show="isShowEdit" @click="handleEdit">{{ $t('public.edit') }}</el-button>
                    </li>
                </ul>
                <!-- 监测点详细编辑模式 -->
                <editForm ref="edit" v-show="!isShowEdit" :getCarrierType="getCarrierType"
                    :getCarrierStatus="getCarrierStatus" :detailObj="detailObj" @editAlarm="handleToAlarmSetFn"
                    @triggerDetail="changeTriggerId" @back="isShowEdit = true" />
            </div>

            <!-- 这里锚点打算用原生HTML写  不考虑用canvas -->
            <div>
                <CarrierImage :equiPoint="equiPoint" :detailObj="detailObj" :isShowEdit="isShowEdit"></CarrierImage>
            </div>

            <!-- 报警触发 -->
            <!--<AlarmDialog ref="alarmDialog" @confirm="triggerConfirm" :isAlarm.sync="isAlarm" :title="title"-->
            <!--    :loading="loading" :tableData="tableData" :choozeTable="choozeTable" :total="total"-->
            <!--    :disabledLoad="disabledLoad" :scene="detailObj['scene_id']" />-->
            <!--<TriggerDetail :id.sync="currentTriggerId"></TriggerDetail>-->
        </div>
        <!-- 关联设备 -->
        <div class="wrapper">
            <span class="bolder font-14">
                {{ $t('integration.installation_point') }}
            </span>
            <div class="hr"></div>
            <RelateDevice :detailObj="detailObj"></RelateDevice>
        </div>

        <!-- 其他信息 -->
        <!--<div class="wrapper">-->
        <!--    <span class="bolder font-14">-->
        <!--        {{ $t('integration.other_information') }}-->
        <!--    </span>-->
        <!--    <div class="hr"></div>-->

        <!--    <Attribute :detail-obj="detailObj"></Attribute>-->
        <!--</div>-->
    </div>
</template>

<script>

import editForm from './components/editDetail.vue'
import CarrierImage from './components/carrierImage/carrierImage.vue'
import TriggerDetail from '@/components/TriggerDetail/TriggerDetail.vue'
import AlarmDialog from '@/pages/business/components/dialog/AlarmDialog.vue'
import { alarmTriggerList } from '@/api/modules/alarm.js'
import { traceInfo } from '@/utils/winDetail'
import RelateDevice from '@/pages/business/components/detail/carrierDetail/components/realteDevice/RelateDevice'
import Attribute from '../Attribute.vue'
import { sampleSrategy } from '@/utils/convert'
import { getLanguage } from '@/lang';

// import linkField from '@/utils/linkField';
// import { mapDeserialize } from '@/utils/mapSerialize';
// import { sensorEx, gatewayEx, displayEx, relayEx } from '@/utils/exception';
export default {
  props: {
    detailObj: {
      type: Object
    },
    getCarrierStatus: {},
    getCarrierType: {}
  },
  watch: {
    detailObj () {
      // this.combineField();
    }
  },
  components: {
    editForm,
    CarrierImage,
    TriggerDetail,
    AlarmDialog,
    RelateDevice,
    Attribute
  },
  computed: {
    disabledLoad: {
      get: function () {
        return this.total <= this.tableData.length
      },
      set (val) {
        return val
      }
    },
    sampleSrategy: () => sampleSrategy
  },
  data () {
    return {
      baseMsg: [
        {
          text: 'public.belong',
          key: 'fullPath'
        },
        {
          text: 'public.status',
          key: 'status'
        },
        {
          text: 'public.type',
          key: 'typeId'
        },
        {
          text: $t('integration.sampling_strategy'),
          key: 'sampleStrategy'
        },
        {
          text: 'public.mode',
          key: 'mode'
        },
        // {
        //   text: 'business.curAbnormal',
        //   key: 'abnormal'
        // },
        {
          text: 'business.traceable',
          key: 'isTrace'
        },
        // {
        //   text: 'business.alarm_status',
        //   key: 'alarmSwitch'
        // },
        // 新增关联无效规则的显示
        {
          text: 'route.invalidRule',
          key: 'exInvalidRule'
        },
        {
          text: 'business.tag',
          key: 'tag'
        },
        {
          text: $t('public.table_desc'),
          key: 'description'
        }
      ],
      isShowEdit: true,
      // 所有 需要显示的点
      equiPoint: null,
      // 报警触发
      isAlarm: false,
      loading: false,
      tableData: [],
      choozeTable: [],
      total: 0,
      title: '',
      currentTriggerId: null,
      dioForm: {
        iDisplayStart: 0,
        iDisplayLength: 15,
        name: '',
        scopeId: ''
      },
      getLanguage
    }
  },
  methods: {
    switchFn (value, key) {
      switch (key) {
        case 'status': {
          return this.statusFn(value)
        }
        case 'abnormal': {
          return value === 1 ? this.$t('public.btn_yes') : this.$t('public.btn_no')
        }
        case 'isTrace': {
          return value === 1 ? this.$t('business.traceable') : this.$t('business.untraceable')
        }
        case 'alarmSwitch': {
          return ''
        }
        case 'exInvalidRule': {
          return  value ? `[${value.name}]` : ''
        }
         case 'typeId': {
          return $t(`carrier[${value}]`)
        }

      }
      return value
    },
    /** 地图跳转 */
    handleToMAPFn () {
      traceInfo(this.detailObj.id)
    },
    statusFn (value) {
      let str = ''

      for (const item of this.getCarrierStatus) {
        if (String(value) === item.code) {
          str = this.getLanguage() === 'zh_CN'?item.name:item.content
          break
        }
      }
      return str
    },
    handleEdit () {
      this.isShowEdit = !this.isShowEdit
    },
    /** 报警设置 */
    handleToAlarmSetFn () {
      // this.goRouter();
      this.isAlarm = true
      this.title = $t('integration.alarm_trigger_setting')
      this.tableData = [];

      (this.dioForm.iDisplayStart = 0), (this.dioForm.iDisplayLength = 15), this.getListFn()

      this.choozeTable = this.detailObj.alarmTriggerList.map(item => {
        item.alarmTriggerId = item.id
        return item
      })
    },
    changeTriggerId (id) {
      this.currentTriggerId = id
    },
    // 选择触发器
    triggerConfirm (trigger) {
      if (!this.detailObj.alarmTriggerList) {
        this.$set(this.detailObj, 'alarmTriggerList', trigger)
      } else this.detailObj.alarmTriggerList = trigger
    },
    getListFn () {
      this.loading = true
      this.dioForm.scopeId = this.detailObj.sceneId
      alarmTriggerList(this.dioForm)
        .then(({ result, pageInfo }) => {
          if (result.length > 0) {
            this.tableData = this.tableData.concat(result)
          } else {
            this.tableData = result
          }
          this.total = pageInfo.total
        })
        .then(() => {
          // getCarrierAlarmTrigger({ carrierId: this.detailObj.id }).then(({ result }) => {
          //     this.choozeTable = this.choozeTable.concat(result);
          // });
          this.choozeTable = this.detailObj.alarmTriggerList
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.$store.dispatch('carrierMode')
  }
}
</script>

<style scoped lang="scss">
.detailContent {
    width: 100%;
    display: flex;
    justify-content: space-between;

    ul {
        // width: 600px;
        flex: 1;

        li {
            line-height: 40px;
            margin-left: 30px;
        }
    }
}

.wrapper {
    padding-left: 30px;
    margin-top: 20px;
}
</style>
